const baseUrl = process.env.REACT_APP_API_ENDPOINT;

if (!baseUrl) {
    throw new Error('API Url is not provided.');
}

export default `${baseUrl}/api`;
